import {BASE_URL} from '@/services/api'
import {METHOD, request} from '@/utils/request'

let CHAT_SAVE_RECORD= `${BASE_URL}/chat/saveChat`
let CHAT_PATIENT_LIST= `${BASE_URL}/chat/getPatientMessage`
let CHAT_DOCTOR_LIST= `${BASE_URL}/chat/getDoctorChatRecord`
let CHAT_TEAM_LIST= `${BASE_URL}/chat/getTeamChatRecord`
let CHAT_PATIENT_ALL_LIST= `${BASE_URL}/chat/getPatientAllMessage`
let CLOSE_NOTICE= `${BASE_URL}/chat/closeNotice`

export async function SaveChatRecord(params) {
  return request(CHAT_SAVE_RECORD, METHOD.POST, params)
}

export async function GetPatientChat(params) {
  return request(CHAT_PATIENT_LIST, METHOD.POST, params)
}

export async function GetDoctorChat(params) {
  return request(CHAT_DOCTOR_LIST, METHOD.POST, params)
}

export async function GetTeamChat(params) {
  return request(CHAT_TEAM_LIST, METHOD.POST, params)
}

export async function GetPatientAllChat(params) {
  return request(CHAT_PATIENT_ALL_LIST, METHOD.POST, params)
}

export async function CloseNotice(params) {
  return request(CLOSE_NOTICE, METHOD.POST, params)
}
export default {
}
